import React, { useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DateRangeSearch = ({
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    handleSearch,
}) => {
    // const [startDate, setStartDate] = useState(null);
    // const [endDate, setEndDate] = useState(null);

    // const handleSearch = () => {
    //     if (startDate && endDate) {
    //         console.log(
    //             "Searching from",
    //             startDate.format("YYYY-MM-DD"),
    //             "to",
    //             endDate.format("YYYY-MM-DD")
    //         );
    //     } else {
    //         console.log("Please select both dates.");
    //     }
    // };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box
                display="flex"
                gap={2}
                alignItems="center"
                flexWrap="wrap"
                marginBottom={5}
            >
                <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={(newValue) => setStartDate(newValue)}
                    renderInput={(params) => (
                        <TextField size="small" {...params} />
                    )}
                />
                <DatePicker
                    label="End Date"
                    value={endDate}
                    onChange={(newValue) => setEndDate(newValue)}
                    renderInput={(params) => (
                        <TextField size="small" {...params} />
                    )}
                />
                <Button variant="contained" onClick={handleSearch}>
                    Search
                </Button>
            </Box>
        </LocalizationProvider>
    );
};

export default DateRangeSearch;
